import React from 'react';
import {useOutlet} from 'reconnect.js';
import styled from 'styled-components';

function BeltBannerSection(props) {
  const {landing} = props;
  const image =
    landing?.custom_layout.belt_section.image ||
    '/images/landing-belt-banner.jpg';
  return <Wrapper image={image} />;
}

const Wrapper = styled.div`
  width: 100%;
  height: 380px;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

export default BeltBannerSection;
